import { Outlet } from "react-router-dom";
import { useOnlineStatus } from "@leagueplatform/web-common";
import {
  ErrorState,
  ERROR_TYPES,
} from "components/error-state/error-state.component";

export const OnlineStatusGate = () => {
  const { isOffline } = useOnlineStatus();

  if (isOffline) {
    return (
      <ErrorState
        error={null}
        isFullPage
        errorType={ERROR_TYPES.NO_CONNECTION}
        hideButton
      />
    );
  }

  return <Outlet />;
};
